import axios from '../../axios/index'
import { Constants } from '../../../Constants';
var fileDownload = require('js-file-download');
export default {
    async getExhibitors(eventAlias,token,callback){
        await axios.get(`${eventAlias}/getEventExibitionHall`,
        {
            'Content-Type': 'application/json',
            headers: 
            { 
                'apiToken': Constants.API_TOKEN ,
                'Authorization' : 'Bearer '+token},
        }).then(response=>{
            callback(null,response.data.exibitions)
        }).catch(error=>{
            callback({
                message : 'Something went wrong'
            },null)
        });
    },
    async getSingleExhibitor(eventAlias,externalLink,token,callback){
        await axios.get(`${eventAlias}/getEventVirtualExibition`,
        {
            params : {exhibitor_id : externalLink},
            'Content-Type': 'application/json',
            headers: 
            { 
                'apiToken': Constants.API_TOKEN ,
                'Authorization' : 'Bearer '+token},
        }).then(response=>{
            callback(null,response.data.exhibitor)
        }).catch(error=>{
            callback({
                message : 'Something went wrong'
            },null)
        });
    },
    downloadBroucher(eventAlias,id,title,callback){
        axios.get(`${eventAlias}/downloadExhibitionBranding`,
            {
                timeout : 120000,
                responseType: 'arraybuffer',
                params: {brandingId : id,isPreview : Constants.isPreview},
                headers: {
                    'Content-Type': 'application/json',
                    'apiToken': Constants.API_TOKEN}
            }).then(response => {
            fileDownload(response.data,title+".pdf")
            callback(null,{})
        }).catch(error => {
            callback(error,null)
        })
    }
}